module.exports = __webpack_public_path__ + "img/hospital-room.10ffa2e2.jpg";